// extracted by mini-css-extract-plugin
export var contactInput = "contact-module--contactInput--gWqEr";
export var contactTextArea = "contact-module--contactTextArea--h9kl6";
export var sectionHeader = "contact-module--sectionHeader--0QlnV";
export var sectionHeaderInner = "contact-module--sectionHeaderInner--W3GWY";
export var sectionHeaderLogo = "contact-module--sectionHeaderLogo--nrii5";